let siteHeader = $('.site-header');

$(window).on('scroll', function () {
    if ($(window).scrollTop() > 10) {
        siteHeader.addClass('scrolled');
    } else {
        siteHeader.removeClass('scrolled');
    }
});

let mobileMenuToggle = $("#site-navigation .menu-toggle"),
    mobileMenu = $("#menu-primary");

mobileMenuToggle.on('click', function () {
    if(mobileMenu.hasClass('menu-open')) {
        closeMobileMenu();
    } else {
        openMobileMenu();
    }
});

function openMobileMenu() {
    mobileMenu.slideDown();
    mobileMenu.addClass('menu-open');
    mobileMenuToggle.addClass('menu-open');
}

function closeMobileMenu() {
    mobileMenu.slideUp();
    mobileMenu.removeClass('menu-open');
    mobileMenuToggle.removeClass('menu-open');
}
